import * as types from '../constants';
import { STATUS } from '../constants';
import { reject, resolve } from '../api';

export const initialCustomerOrganizationsState = {
  customerOrganizationsStatus: STATUS.IDLE,
  customerOrganizationSubscription: [],
  customerOrganizationSubscriptionStatus: STATUS.IDLE,
  customerOrganizationsData: [],
  customerOrganizationsCreationData: [],
  customerOrganizationsCreationStatus: STATUS.IDLE,
  usersInfoForStaffMember: [],
  usersInfoForStaffMemberStatus: STATUS.IDLE,
};

export default (state = initialCustomerOrganizationsState, action) => {
  switch (action?.type) {
    case types.RESET_CREATE_ORGANIZATION_STATUS: {
      return {
        ...state,
        customerOrganizationsCreationData: [],
        customerOrganizationsCreationStatus: STATUS.IDLE,
      };
    }

    case types.LOAD_CUSTOMER_ORGANIZATIONS_LIST: {
      return {
        ...state,
        customerOrganizationsStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_CUSTOMER_ORGANIZATIONS_LIST): {
      return {
        ...state,
        customerOrganizationsCount: action?.payload?.count,
        customerOrganizationsData: action?.payload?.results,
        customerOrganizationsStatus: STATUS.LOADED,
      };
    }
    case reject(types.LOAD_CUSTOMER_ORGANIZATIONS_LIST):
      return {
        ...state,
        error: true,
        customerOrganizationsStatus: STATUS.ERROR,
      };
    case types.LOAD_CUSTOMER_ORGANIZATIONS_LIST_PAGE: {
      return {
        ...state,
        customerOrganizationsStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_CUSTOMER_ORGANIZATIONS_LIST_PAGE): {
      return {
        ...state,
        customerOrganizationsCount: action?.payload?.count,
        customerOrganizationsData: action?.payload?.results,
        customerOrganizationsStatus: STATUS.LOADED,
      };
    }
    case reject(types.LOAD_CUSTOMER_ORGANIZATIONS_LIST_PAGE):
      return {
        ...state,
        error: true,
        customerOrganizationsStatus: STATUS.ERROR,
      };
    case resolve(types.UPDATE_CUSTOMER_ORGANIZATION): {
      return {
        ...state,
        customerOrganizationsData: action?.payload?.results,
        customerOrganizationsStatus: STATUS.LOADED,
      };
    }
    case reject(types.UPDATE_CUSTOMER_ORGANIZATION):
      return {
        ...state,
        error: true,
        customerOrganizationsStatus: STATUS.ERROR,
      };
    case types.CREATE_CUSTOMER_ORGANIZATION: {
      return {
        ...state,
        customerOrganizationsCreationStatus: STATUS.LOADING,
      };
    }
    case resolve(types.CREATE_CUSTOMER_ORGANIZATION): {
      return {
        ...state,
        customerOrganizationsCreationData: action?.payload,
        customerOrganizationsCreationStatus: STATUS.LOADED,
      };
    }
    case reject(types.CREATE_CUSTOMER_ORGANIZATION):
      return {
        ...state,
        error: true,
        customerOrganizationsCreationStatus: STATUS.ERROR,
      };
    case types.LOAD_CUSTOMER_SUBSCRIPTION_PLAN: {
      return {
        ...state,
        customerSubscriptionPlanStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_CUSTOMER_SUBSCRIPTION_PLAN): {
      return {
        ...state,
        customerSubscriptionPlan: action?.payload,
        customerSubscriptionPlanStatus: STATUS.LOADED,
      };
    }
    case reject(types.LOAD_CUSTOMER_SUBSCRIPTION_PLAN):
      return {
        ...state,
        error: true,
        customerSubscriptionPlanStatus: STATUS.ERROR,
      };
    case types.CREATE_CUSTOMER_SUBSCRIPTION: {
      return {
        ...state,
        customerOrganizationSubscriptionStatus: STATUS.LOADING,
      };
    }
    case resolve(types.CREATE_CUSTOMER_SUBSCRIPTION): {
      return {
        ...state,
        customerOrganizationSubscription: action?.payload,
        customerOrganizationSubscriptionStatus: STATUS.LOADED,
      };
    }
    case reject(types.CREATE_CUSTOMER_SUBSCRIPTION):
      return {
        ...state,
        error: true,
        customerOrganizationsStatus: STATUS.ERROR,
        customerOrganizationSubscriptionStatus: STATUS.ERROR,
      };

    case resolve(types.UPDATE_CUSTOMER_SUBSCRIPTION): {
      return {
        ...state,
        customerOrganizationSubscription: action?.payload,
        customerOrganizationSubscriptionStatus: STATUS.LOADED,
      };
    }
    case reject(types.UPDATE_CUSTOMER_SUBSCRIPTION):
      return {
        ...state,
        error: true,
        customerOrganizationsStatus: STATUS.ERROR,
        customerOrganizationSubscriptionStatus: STATUS.ERROR,
      };
    case types.LOAD_CUSTOMER_ORGANIZATION: {
      return {
        ...state,
        customerOrganizationStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_CUSTOMER_ORGANIZATION): {
      return {
        ...state,
        customerOrganizationData: action?.payload,
        customerOrganizationStatus: STATUS.LOADED,
      };
    }
    case reject(types.LOAD_CUSTOMER_ORGANIZATION):
      return {
        ...state,
        error: true,
        customerOrganizationStatus: STATUS.ERROR,
      };
    case types.LOAD_CUSTOMER_ORGANIZATION_USERS_LIST: {
      return {
        ...state,
        customerOrganizationUsersStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_CUSTOMER_ORGANIZATION_USERS_LIST): {
      return {
        ...state,
        customerOrganizationUsersCount: action?.payload?.count,
        customerOrganizationUsersData: action?.payload?.results,
        customerOrganizationUsersStatus: STATUS.LOADED,
      };
    }
    case reject(types.LOAD_CUSTOMER_ORGANIZATION_USERS_LIST):
      return {
        ...state,
        error: true,
        customerOrganizationUsersStatus: STATUS.ERROR,
      };
    case types.LOAD_CUSTOMER_ORGANIZATION_USERS_LIST_PAGE: {
      return {
        ...state,
        customerOrganizationUsersStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_CUSTOMER_ORGANIZATION_USERS_LIST_PAGE): {
      return {
        ...state,
        customerOrganizationUsersCount: action?.payload?.count,
        customerOrganizationUsersData: action?.payload?.results,
        customerOrganizationUsersStatus: STATUS.LOADED,
      };
    }
    case reject(types.LOAD_CUSTOMER_ORGANIZATION_USERS_LIST_PAGE):
      return {
        ...state,
        error: true,
        customerOrganizationUsersStatus: STATUS.ERROR,
      };
    case types.UPDATE_CUSTOMER_ORGANIZATION_USER: {
      return {
        ...state,
        updateCustomerOrganizationUserStatus: STATUS.LOADING,
      };
    }
    case resolve(types.UPDATE_CUSTOMER_ORGANIZATION_USER): {
      return {
        ...state,
        updateCustomerOrganizationUserData: action?.payload,
        updateCustomerOrganizationUserStatus: STATUS.LOADED,
      };
    }
    case reject(types.UPDATE_CUSTOMER_ORGANIZATION_USER):
      return {
        ...state,
        error: true,
        updateCustomerOrganizationUserStatus: STATUS.ERROR,
      };
    case types.CREATE_CUSTOMER_ORGANIZATION_USER: {
      return {
        ...state,
        createCustomerOrganizationUserStatus: STATUS.LOADING,
      };
    }
    case resolve(types.CREATE_CUSTOMER_ORGANIZATION_USER): {
      return {
        ...state,
        createCustomerOrganizationUserData: action?.payload,
        createCustomerOrganizationUserStatus: STATUS.LOADED,
      };
    }
    case reject(types.CREATE_CUSTOMER_ORGANIZATION_USER):
      return {
        ...state,
        error: true,
        createCustomerOrganizationUserStatus: STATUS.ERROR,
      };
    case types.CREATE_COMMUNITY_CUSTOMER_ORGANIZATION_USER: {
      return {
        ...state,
        createCustomerOrganizationUserStatus: STATUS.LOADING,
      };
    }
    case resolve(types.CREATE_COMMUNITY_CUSTOMER_ORGANIZATION_USER): {
      return {
        ...state,
        createCustomerOrganizationUserData: action?.payload,
        createCustomerOrganizationUserStatus: STATUS.LOADED,
      };
    }
    case reject(types.CREATE_COMMUNITY_CUSTOMER_ORGANIZATION_USER):
      return {
        ...state,
        error: true,
        createCustomerOrganizationUserStatus: STATUS.ERROR,
      };

    case types.LOAD_USERS_INFO_FOR_STAFF_MEMBER: {
      return {
        ...state,
        usersInfoForStaffMemberStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_USERS_INFO_FOR_STAFF_MEMBER): {
      return {
        ...state,
        usersInfoForStaffMember: action?.payload,
        usersInfoForStaffMemberStatus: STATUS.LOADED,
      };
    }
    case reject(types.LOAD_USERS_INFO_FOR_STAFF_MEMBER):
      return {
        ...state,
        error: true,
        usersInfoForStaffMember: [],
        usersInfoForStaffMemberStatus: STATUS.ERROR,
      };
    default:
      return state;
  }
};
